module.exports = __webpack_public_path__ + "img/hologram-map-2.e6e5e826.svg";